import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Spinner } from "reactstrap";
import cogoToast from "cogo-toast";
import Swal from "sweetalert2";
import {
  deleteWorkforcePlanningApi,
  getWorkforcePlanningDetailsApi,
} from "../../../services/Api";
import { SUCCESS_RESULT } from "../../../Constants";
import ability from "../../config/defineAbility";
import { PERMS } from "../../config/perms";
import WorkforcePlanningDetailsContent from "./WorkforcePlanningDetailsContent";

const WorkforcePlanningDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const canDelete = ability.can(PERMS.DELETE, PERMS.CAN_DELETE_WORKFORCE_PLANNING);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getWorkforcePlanningDetailsApi({ id })
      .then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data.status === SUCCESS_RESULT) {
          setRecord(res.data.data || null);
        } else {
          cogoToast.error(res.data?.message || "Failed to load details", { hideAfter: 5 });
          history.push("/hrm/workforce-planning");
        }
      })
      .catch((err) => {
        setLoading(false);
        cogoToast.error(
          err?.response?.data?.message || "Something went wrong loading details.",
          { hideAfter: 5 }
        );
        history.push("/hrm/workforce-planning");
      });
  }, [id, history]);

  const handleDelete = () => {
    if (!canDelete) {
      cogoToast.error("You do not have permission to delete workforce planning records.", {
        hideAfter: 4,
      });
      return;
    }
    if (!record?.id) return;
    Swal.fire({
      title: "Delete this record?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete",
    }).then((result) => {
      if (!result.isConfirmed) return;
      deleteWorkforcePlanningApi({ id: record.id })
        .then((res) => {
          if (res.status === 200 && res.data.status === SUCCESS_RESULT) {
            cogoToast.success(res.data.message || "Deleted", { hideAfter: 3 });
            history.push("/hrm/workforce-planning");
          } else {
            cogoToast.error(res.data?.message || "Delete failed", { hideAfter: 5 });
          }
        })
        .catch((err) => {
          cogoToast.error(
            err?.response?.data?.message || "Something went wrong deleting.",
            { hideAfter: 5 }
          );
        });
    });
  };

  if (loading) {
    return (
      <div className="container-xl mt-4 text-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="container-xl mt-4 mb-5">
      <WorkforcePlanningDetailsContent
        record={record}
        showBackLink
        showActions
        canDelete={canDelete}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default WorkforcePlanningDetails;
